import React from "react";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import pretty from "Shared/pretty";
import AmountField from "Components/Shared/FormComponents/AmountField/AmountField";

const PaymentAmountInput = () => {
  const { offCyclePaymentOptions } = usePartnerConfig();
  const maxAmount = offCyclePaymentOptions.maxAmountCents;

  const formattedAmmount = pretty.dollar(maxAmount);


  return <AmountField
    name="paymentAmount"
    maxAmount={maxAmount}
    errorMessages={ {
      range: `Amount cannot be over ${formattedAmmount} ${offCyclePaymentOptions.cycleRequiresApproval ? "" : "without secondary approval"}`,
    } }
  />;
};

export default PaymentAmountInput;
